<template>
  <ul class="pagination pagination-rounded justify-content-end mt-3">
    <li class="page-item" :class="isInFirstPage ? 'disabled' : ''">
      <a
        @click="onClickPreviousPage"
        class="page-link"
        href="javascript: void(0);"
      >
        <i class="mdi mdi-chevron-left"></i>
      </a>
    </li>
    <li class="page-item" :class="isInFirstPage ? 'disabled' : ''">
      <a
        @click="onClickFirstPage"
        class="page-link page-link-1"
        href="javascript: void(0);"
      >
        First
      </a>
    </li>
    <!-- Visible Buttons Start -->

    <li v-for="(page, index) in pages" class="page-item" :key="index">
      <a
        class="page-link"
        @click="onClickPage(page.name)"
        :disabled="page.isDisabled"
        :class="page.name == currentPage ? 'active' : ''"
        href="javascript: void(0);"
      >
        {{ page.name }}
      </a>
    </li>

    <!-- Visible Buttons End -->
    <li class="page-item" :class="isInLastPage ? 'disabled' : ''">
      <a
        @click="onClickLastPage"
        class="page-link page-link-1"
        href="javascript: void(0);"
      >
        Last
      </a>
    </li>
    <li class="page-item" :class="isInLastPage ? 'disabled' : ''">
      <a class="page-link" @click="onClickNextPage" href="javascript: void(0);">
        <i class="mdi mdi-chevron-right"></i>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 10,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },
  computed: {
    startPage() {
      // When on the first page
      if (this.currentPage === 1) {
        return 1;
      }

      // When on the last page
      if (this.currentPage === this.totalPages) {
        return this.totalPages + 1 - this.maxVisibleButtons;
      }

      // When inbetween
      return this.currentPage - 1;
    },
    pages() {
      const range = [];
      for (
        let i = this.startPage;
        i <=
        Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
        i++
      ) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage,
        });
      }

      return range;
    },
    isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage() {
      return this.currentPage === this.totalPages;
    },
  },
  methods: {
    onClickPreviousPage() {
      if (this.currentPage == 1) return;
      this.$emit("pagechanged", this.currentPage - 1);
    },
    onClickPage(page) {
      this.$emit("pagechanged", page);
    },
    onClickNextPage() {
      if (this.currentPage == this.totalPages) return;
      this.$emit("pagechanged", this.currentPage + 1);
    },
    onClickFirstPage() {
      this.$emit("pagechanged", 1);
    },
    onClickLastPage() {
      this.$emit("pagechanged", this.totalPages);
    },
  },
};
</script>

<style>
.page-link-1 {
  width: 40px !important;
}
</style>

<!-- 
    onClickFirstPage() {
      this.$emit("pagechanged", 1);
    },
      onClickLastPage() {
      this.$emit("pagechanged", this.totalPages);
    },
       isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage() {
      return this.currentPage === this.totalPages;
    },
    <li class="page-item">
      <a
        class="page-link"
        @click="onClickLastPage"
        :disabled="isInLastPage"
        href="javascript: void(0);"
      >
        Last
      </a>
    </li> 
 <li class="page-item disabled">
      <a
        @click="onClickFirstPage"
        :disabled="isInFirstPage"
        class="page-link"
        href="javascript: void(0);"
      >
        First
      </a>
    </li>-->
